import { Result } from '@/types/base';
import { AgGridRequest } from '@/types/models';
import { _Guid } from './Guid';
import request from './request';

class CrudRequest<T> {
    public entity: string;

    constructor(entity: string) {
        this.entity = entity;
    }

    public async create(args: T): Promise<Result<T>> {
        return request(`/${this.entity}`, {
            method: 'POST',
            data: args,
        });
    }

    public async update<U>(id: string, data: U): Promise<Result<T>> {
        return request(`/${this.entity}/${id}`, {
            method: 'POST',
            data,
        });
    }

    public async get(id: string): Promise<Result<T>> {
        return request(`/${this.entity}/${id}`, {
            method: 'GET',
        });
    }

    public async delete(id: string) {
        return request(`/${this.entity}/${id}/delete`, {
            method: 'POST',
        });
    }

    public getAgList = async (params: AgGridRequest, id?: _Guid): Promise<Result<T[]>> => {
        return request(`/${this.entity}/ag`, {
            method: 'POST',
            data: params,
        });
    };
}

export default CrudRequest;
